module.exports = __webpack_public_path__ + "img/banner1.bab51080.png";